import { useShoppingBasketInfoWithDefaultData } from '#src/clientState/providers';
import { PageErrorEnum } from '#src/components/PageError';
import { PageError } from '#src/components/public';
import { UniversalShoppingBasketCheckoutStatus } from '#src/generated/graphql';
import React from 'react';

export const BASE_STORAGE_KEY =
  'frontend-shopping-basket::original-sb-checkout-status--';

export const ShoppingBasketStatusChecker = ({ children, alreadyProcessed }) => {
  const { checkoutStatus, shoppingBasketId } =
    useShoppingBasketInfoWithDefaultData();

  const STORAGE_KEY = `${BASE_STORAGE_KEY}${shoppingBasketId}`;

  const isAlreadyProcessed =
    checkoutStatus === UniversalShoppingBasketCheckoutStatus.Finished &&
    !sessionStorage.getItem(STORAGE_KEY);

  const shouldSetOriginalCheckoutStatus =
    Boolean(checkoutStatus) &&
    checkoutStatus !== UniversalShoppingBasketCheckoutStatus.Finished &&
    !sessionStorage.getItem(STORAGE_KEY);

  if (isAlreadyProcessed) {
    return alreadyProcessed;
  }

  if (shouldSetOriginalCheckoutStatus) {
    sessionStorage.setItem(STORAGE_KEY, checkoutStatus);
  }

  return children;
};

export const AlreadyProcessedManager = ({ children }) => {
  return (
    <ShoppingBasketStatusChecker
      alreadyProcessed={
        <PageError pageErrorStatus={PageErrorEnum.SHOPPING_BASKET_CLOSED} />
      }
    >
      {children}
    </ShoppingBasketStatusChecker>
  );
};
